import React, { useEffect } from 'react';
import './programassociales.css';
import { programassociales } from '../../json/programassociales';

const Atencionalpueblo = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className='container-full-width'>
      <div className='row'>
        <div className='col-12'>
          <h3 className='title'>Programa "Atención al Pueblo"</h3>
          <hr className='hr-gob' />
        </div>
      </div>
     
      <div className='row'>
        <div className='col-12 container-armon'>
          <div className='armo-collapse'>
            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
             
              <div style={{ textAlign: 'left' }}>
                <h5 style={{ fontWeight: 'bold', color: 'var(--wine)' }}>Descripción del Programa</h5>
                <p>
                Brindar apoyo a personas con carencias sociales en los 84 municipios del estado de Hidalgo, mediante asistencia económica o en especie, adaptándose a las necesidades específicas de cada beneficiario para mejorar su calidad de vida y bienestar.
                </p>
                <p>
                Atención de Necesidades Diversas: Proporcionando apoyo adaptable a diferentes tipos de carencias sociales, como vivienda, alimentación, educación, salud y necesidades económicas básicas.
                </p>
                <h6 className='description' style={{ marginTop: '20px' }}>
                </h6>
                <h5 style={{ fontWeight: 'bold', color: 'var(--wine)' }}>Objetivo del Programa</h5>
                <p>
                Asegurar que los apoyos lleguen a todas las personas, garantizando la  accesibilidad en todos los 84 municipios de Hidalgo.
                </p>
                <p>
                Con respuesta rápida y efectiva, garantizando un proceso de solicitud y entrega de ayuda ágil y eficiente a los beneficiarios.
                </p>
                <h5 style={{ fontWeight: 'bold', color: 'var(--wine)' }}>Población Objetivo</h5>
                <p>
                Brindar apoyo a personas con carencias sociales en los 84 municipios del estado de Hidalgo, mediante asistencia económica o en especie, adaptándose a las necesidades específicas de cada beneficiario para mejorar su calidad de vida y bienestar.
                </p>
                <h5 style={{ fontWeight: 'bold', color: 'var(--wine)' }}>Cobertura</h5>
                <p>
                El Programa tendrá cobertura en los 84 municipios del Estado de Hidalgo en las 12 regiones contenidas en el Plan Estatal de Desarrollo 2022-2028. Los apoyos se otorgarán conforme a la capacidad que permita la disponibilidad presupuestal y financiera.
                </p>
                <h5 style={{ fontWeight: 'bold', color: 'var(--wine)' }}>Vigencia</h5>
                <p>
                Anual
                </p>
                <h5 style={{ fontWeight: 'bold', color: 'var(--wine)' }}>Áreas de atención</h5>
                <p>
                  
                <ul>
                <li><b>Secretaría de Bienestar en Inclusión Social</b></li>
                <dd>Blvd. Felipe Angeles, Km. 93.50, Centro Minero, Edificio 1B, Col, Venta Prieta, 42080 Pachuca de Soto, Hgo.</dd>
                <li><b>Subsecretaría de Desarrollo Social y Humano</b></li>
                <dd>Calle Francisco Maldonado Lecona #101, Segundo Piso, Colonia Ampliación Santa Julia CP.  42080. Pachuca de Soto; Hgo.</dd>
                </ul></p>
                <h5 style={{ fontWeight: 'bold', color: 'var(--wine)' }}>Personas Responsables del Programa</h5>
                <p>
                Lic. David Robles Hernández: Subsecretario de Desarrollo Social y Humano
                </p>
                <p>
                <h5 style={{ fontWeight: 'bold', color: 'var(--wine)' }}>Teléfono de Contacto</h5>
                <p>
                Pendiente
                </p>
                <h5 style={{ fontWeight: 'bold', color: 'var(--wine)' }}>Reglas de Operación</h5>
                <ul>
                <li>
                <a
                href='https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/SEBISO/transparencia/pdfs/rops/2025/ROPs_Programa_de_Atención_al_Pueblo_EF_2025.pdf'
                target='_blank'
                rel="noopener noreferrer"
                className='link-custom'
                >ROP's 2025</a>
                </li>
                <li>
                <a
                href='https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/SEBISO/transparencia/pdfs/rops/2024/ROP_Atenci%C3%B3n_al_Pueblo_2024_ene_31_alc7_05.pdf'
                target='_blank'
                rel="noopener noreferrer"
                className='link-custom'
                >ROP's 2024</a>
                </li>
                <li><a
                href='https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/SEBISO/transparencia/pdfs/rops/2024/Reforma_ROP_Programa_Atenci%C3%B3n_al_Pueblo_2024.pdf'
                target='_blank'
                rel="noopener noreferrer"
                className='link-custom'
                >Reforma 02 de febrero de 2024</a><br />
                </li>
                </ul>

                <h5 style={{ fontWeight: 'bold', color: 'var(--wine)' }}>Enlaces a los catálogos estatal y nacional</h5>
                <ul>
                <li>
                <a
                href='https://ruts.hidalgo.gob.mx/ver/11198'
                target='_blank'
                rel="noopener noreferrer"
                className='link-custom'
                >Registro Único de Trámites y Servicios (RUTS)</a>
                </li>
                <li>
                <a
                href='https://catalogonacional.gob.mx/FichaTramite?traHomoclave=SBIS-2024-11547-018-A'
                target='_blank'
                rel="noopener noreferrer"
                className='link-custom'
                >Catalogo Nacional de Regulaciones Trámites y Servicios (CNARTyS)</a>
                </li>
                </ul>
                </p>

              </div>
            </div>
            
          </div>
        </div>
      </div>   
    </div>    
  
  );
};

export default Atencionalpueblo;